import { render, staticRenderFns } from "./BuyCar.vue?vue&type=template&id=e1981220&scoped=true&"
import script from "./BuyCar.vue?vue&type=script&lang=js&"
export * from "./BuyCar.vue?vue&type=script&lang=js&"
import style0 from "./BuyCar.vue?vue&type=style&index=0&id=e1981220&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1981220",
  null
  
)

export default component.exports